define('pad/pad',[], function() {
	return function pad(string, desiredLength, padCharacter) {
		
		string = string.toString();
		padCharacter = padCharacter || '0';
		desiredLength = desiredLength || 2

		while (string.length < desiredLength) {
			string = padCharacter + string;
		}

		return string;
	}
});
